// CancelConfirmModal.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CancelConfirmModal = ({
  showCancelConfirmModal,
  setShowCancelConfirmModal,
  selectedTransNo,
  cancelReason,
  setCancelReason,
  handleCancelTransaction
}) => {
  return (
    <AnimatePresence>
      {showCancelConfirmModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-y-0 left-0 tracker-aware-modal-layer bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]"
          onClick={() => setShowCancelConfirmModal(false)}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-2xl p-6 w-full max-w-md mx-4 shadow-2xl border border-gray-100"
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Cancelling Transaction
            </h2>
            <p className="text-gray-600 mb-4">
              You are about to cancel transaction with TRN #{selectedTransNo}.
              This action cannot be undone. Please provide a reason.
            </p>
            <textarea
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              placeholder="Reason for cancellation (required)"
              className="w-full p-3 border border-gray-300 rounded-md resize-vertical mb-2"
              rows={4}
              maxLength={1000}
              minLength={2}
            />
            <div className="text-right text-sm text-gray-500 mb-4">
              {cancelReason.length}/1000 characters
              {cancelReason.length < 2 && (
                <span className="text-red-500 ml-1">
                  (Minimum 2 characters required)
                </span>
              )}
              {cancelReason.length > 1000 && (
                <span className="text-red-500 ml-1">
                  (Maximum 1000 characters exceeded)
                </span>
              )}
            </div>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowCancelConfirmModal(false);
                  setCancelReason("");
                }}
                className="px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
              >
                No
              </button>
              <button
                onClick={handleCancelTransaction}
                disabled={cancelReason.length < 2 || cancelReason.length > 1000}
                className={`px-4 py-2 font-medium rounded-lg ${
                  cancelReason.length < 2 || cancelReason.length > 1000
                    ? "bg-red-300 text-gray-500 cursor-not-allowed"
                    : "bg-red-600 text-white hover:bg-red-700"
                }`}
              >
                Yes, Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CancelConfirmModal;
